<template>
  <v-select
    v-bind="$attrs"
    :model-value="modelValue"
    @update:modelValue="emit('update:modelValue', $event)"
    :items="items"
    :item-title="itemTitle"
    :item-value="itemValue"
    multiple
    variant="outlined"
    hide-details
    class="w-100 mb-4"
    clearable
    density="compact"
    :placeholder="placeholder"
    :menu-props="{ maxWidth: '100%' }"
  >
    <template #item="{ props, item }">
      <div v-bind="{ ...props, title: undefined }" class="custom-option mx-2">
          <v-checkbox
            :model-value="(modelValue || []).includes(resolveItemValue(item.raw))"
            class="d-flex align-center justify-center"
          />
        <span>{{ resolveItemTitle(item.raw) }}</span>
      </div>
    </template>

    <template #no-data>
      <slot name="no-data"/>
    </template>
  </v-select>
</template>

<script setup lang="ts">

const props = defineProps<{
  modelValue: any[]
  items: any[]
  itemTitle?: string | ((item: any) => string)
  itemValue?: string | ((item: any) => any)
  placeholder?: string
}>()

const emit = defineEmits<(e: 'update:modelValue', value: any[]) => void>()

function resolveItemTitle(item: any): string {
  if (typeof props.itemTitle === 'function') return props.itemTitle(item)
  return item?.[props.itemTitle || 'label']
}

function resolveItemValue(item: any): any {
  if (typeof props.itemValue === 'function') return props.itemValue(item)
  return item?.[props.itemValue || 'value']
}
</script>

<style scoped lang="scss">
.custom-option {
  display: flex;
  align-items: center;
  cursor: pointer;
  min-height: 40px !important;
  height: 40px !important;
  &:hover {
    background-color: #f5f5f5;
  }
}
:deep(.v-field__input) {
  opacity: 1 !important;
}
:deep(.v-field__input input) {
  margin-top:2px;
  &::placeholder {
    color: rgb(var(--v-theme-grey-500)) !important;
    opacity: 1 !important;
  }
}
</style>
